import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
export default (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(Heading, props, children);
});
var Heading = styled.h1.withConfig({
  displayName: "Heading",
  componentId: "sc-1lbhrwu-0"
})([""]);